(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-gift-cart-sync"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mhGiftCartSyncReady) return;
  window.mhGiftCartSyncReady = true;
  let timer;
  let remaining = 0;
  let running = false;
  let generation = 0;
  const fingerprint = items => items.map(item => `${item.key}:${item.quantity}`).sort().join('|');
  const queue = () => {
    if (!document.getElementById('AjaxCartForm')) return;
    generation++;
    remaining = 4;
    clearTimeout(timer);
    if (!running) timer = setTimeout(sync, 250);
  };
  const sync = async () => {
    if (running || remaining < 1) return;
    running = true;
    remaining--;
    const currentGeneration = generation;
    try {
      const cartForm = document.getElementById('AjaxCartForm');
      if (!cartForm || document.hidden) return;
      if (cartForm.querySelector('form.processing')) return;
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (currentGeneration !== generation || cartForm.querySelector('form.processing')) return;
      const displayed = Array.from(cartForm.querySelectorAll('[data-js-cart-item]')).map(item => ({key: item.dataset.id, quantity: Number(item.dataset.qty)}));
      if (fingerprint(displayed) !== fingerprint(cart.items) && typeof window.refreshCart === 'function') {
        await window.refreshCart({open: false});
      }
    } catch (error) {
      return;
    } finally {
      running = false;
      if (remaining > 0) timer = setTimeout(sync, 900);
    }
  };
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('.bogos-gift-item-add-btn')) queue();
  }, true);
  document.addEventListener('cart-updated', queue, true);
  document.addEventListener('fg-today-offer:success', queue);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-recipes-nav"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mh-recipes-menu')){
  customElements.define('mh-recipes-menu',class extends HTMLElement{
    connectedCallback(){
      this.disclosure=this.querySelector('details');
      this.onOutside=event=>{if(!this.contains(event.target))this.disclosure.open=false};
      this.onEscape=event=>{if(event.key==='Escape'&&this.disclosure.open){event.stopPropagation();this.disclosure.open=false;this.querySelector('summary').focus()}};
      document.addEventListener('click',this.onOutside);
      this.addEventListener('keydown',this.onEscape);
    }
    disconnectedCallback(){document.removeEventListener('click',this.onOutside);this.removeEventListener('keydown',this.onEscape)}
  });
}
  } catch(e) { console.error(e); }
})();

})();
